export const FORM_HEADER_JSON = { "Content-Type": "application/json" };

export const FORM_HEADER_FORMDATA = { "Content-Type": "multipart/form-data" };

export const FORM_HEADER_ENCODED = {
	"Content-Type": "application/x-www-form-urlencoded",
};
